import { RatingsModal } from 'components/RatingsModal';
import { useState } from 'react';
import { COLORS } from 'styles/constants';
import { LiquidButton } from '../../LiquidButton';
import { Text as Paragraph } from '../../Typography';
import { IRatingBanner } from '../index';
import { Heading } from './Heading';
import { StarsButtonContent } from './StarsButtonContent';

export const InnerContent = ({
  ratingMsg,
  ratingData,
  settingRateData,
  trackingEvent,
  recipeTitle,
  showCommentField = false,
  showContactPageData = false,
  contactPageData = '',
  isPreparationStep = false,
}: IRatingBanner) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Heading
        show={!isPreparationStep}
        ratingMsg={ratingMsg}
        ratingData={ratingData}
        isRatingGiven={settingRateData.isRatingGiven}
      />
      <button
        className={isPreparationStep ? '-ml-2' : 'w-max m-auto block'}
        onClick={openModal}
        type="button"
        disabled={settingRateData.isRatingGiven}
      >
        <StarsButtonContent settingRateData={settingRateData} ratingData={ratingData} />
      </button>
      <Paragraph className="uppercase m-0 text-gray-dark min-h-18" tag="div" type="lead">
        {settingRateData.isRatingGiven && ratingMsg.message[settingRateData.ratingGiven - 1]}
      </Paragraph>
      <button onClick={openModal} type="button" className="pb-6">
        <LiquidButton
          text={ratingMsg?.ratingBtn || 'Rate recipe'}
          height={50}
          width={200}
          color={COLORS.primary}
          textColor={COLORS.white}
        />
      </button>
      <RatingsModal
        modalIsOpen={modalIsOpen}
        setClose={closeModal}
        ratingData={ratingData}
        ratingMsg={ratingMsg}
        settingRateData={settingRateData}
        trackingEvent={trackingEvent && trackingEvent}
        recipeTitle={recipeTitle}
        showCommentField={showCommentField}
        showContactPageData={showContactPageData}
        contactPageData={contactPageData}
      />
    </>
  );
};
